import React, { useEffect, useState } from 'react';
import LoadingOverlay from 'react-loading-overlay';
import queryString from 'query-string';
import {
  addCouponToCart,
  getCartId,
  getDateFormat,
} from '../../services/promotion/utils.service';
import { getCartData } from '../../actions/cartAction';
import { connect } from 'react-redux';
import CustomSweetAlert from '../../common/customSweetAlert/CustomSweetAlert';
import { couponStatus, TEXT_CONFIRM_BUTTON } from '../../common/commonConstant';
import { useLocation } from 'react-router-dom';

const CouponPanel = (props) => {
  const [coupons, setCoupons] = useState([]);

  const [loading, setLoading] = useState(false);

  const [couponCode, setCouponCode] = useState('');
  const location = useLocation();
  const params = queryString.parse(location.search);
  const [selected = [], setSelected] = useState([]);
  const [eligibleCoupons, setEligibleCoupons] = useState([]);
  const [nonEligibleCoupons, setNonEligibleCoupons] = useState([]);


  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    const customerFOA = JSON.parse(localStorage.getItem('customerFOAData'));
    if (!customerFOA) {
      const coupons = props.cartData ? props.cartData?.coupons : [];
      setCoupons(coupons);
      if (coupons && coupons.length > 0) {
        const eligibleCoupons = coupons.filter((item) => {
          return item.cartCouponType === 'redeem'
        })
        const nonEligibleCoupons = coupons.filter((item) => {
          return item.cartCouponType === 'nonRedeem'
        })
        const inCartCoupons = coupons.filter((item) => {
          return item.status.toLowerCase() === couponStatus.InCart
        })
        const appliedIds = inCartCoupons.map(coupon => coupon.id);
        setSelected(appliedIds);
        setEligibleCoupons(eligibleCoupons)
        setNonEligibleCoupons(nonEligibleCoupons)
      }
    }
  };

  useEffect(() => {
    if (props.isOpen) {
      fetchData();
    }
    initState();
  }, [props.isOpen]);

  const initState = () => {
    setCouponCode('');
  };

  const onCodeChange = (e) => {
    e.preventDefault();
    const couponCode = e.target.value;
    setCouponCode(couponCode);
  };

  const onSubmitCode = async () => {
    if (!couponCode) {
      return CustomSweetAlert({
        title: "",
        text: 'โปรดระบุรหัสโค้ดส่วนลด',
        confirmButtonText: "ตกลง",
      });
    }

    try {
      setLoading(true);
      const couponList = [couponCode];
      const response = await addCouponToCart(couponList, props.cartId);
      if (!response.success) {
        const errorMessage = response.error[0].th_message;
        CustomSweetAlert({
          title: "",
          text: errorMessage,
          confirmButtonText: "ตกลง",
        });
        setLoading(false);
        return;
      }
      props.getCartData('FULL', getCartId(params.isInstallment));
      setLoading(false);
      props.onClose();
    } catch (error) {
      console.log(error);
    }
  };

  const handleSelect = (value, status) => {
    if (status.toLowerCase() === couponStatus.InCart) return;

    const index = selected.indexOf(value);
    if (index >= 0) {
      selected.splice(index, 1);
    } else {
      selected.push(value);
    }
    setSelected([...selected]);
  };

  const onSubmit = async () => {

    const newCoupons = eligibleCoupons
      .filter(coupon =>
        selected.includes(coupon.id) && coupon.status.toLowerCase() !== couponStatus.InCart)
      .map(c => c.id);

    if (!newCoupons.length) {
      return CustomSweetAlert({
        title: "",
        text: 'คุณยังไม่ได้เลือกคูปอง',
        confirmButtonText: "ตกลง",
      });
    }
    try {
      setLoading(true);
      const response = await addCouponToCart(newCoupons, props.cartId);
      if (!response.success) {
        const errorMessage = response.error[0].th_message;
        CustomSweetAlert({
          title: "",
          text: errorMessage,
          confirmButtonText: "ตกลง",
        });
        setLoading(false);
        return;
      }
      // props.getCartData('FULL');
      setLoading(false);
      props.onClose();
    } catch (error) {
      console.log(error);
    }
  };


  const renderCouponContainer = (value, index) => {
    return (
      <div key={index} className={`coupon-container bg-coupon ${(value.cartCouponType === 'nonRedeem') ? 'disable-coupon' : ''}`}>
        <div className="dark-red coupon-detail">
          <div className="coupon-title">{`${value.name}`}</div>
          <div className="coupon-desc">{value?.value ? `ลด ${value?.value}` : ''}</div>
        </div>
        <div className="box-right">
          <div className="dark-red text-stock">
            <div className="text-center">
              <button className={`away-button coupon-button ${selected.includes(value.id) ? 'coupon-button-inactive' : (value.cartCouponType === 'nonRedeem') ? 'disable-coupon-button' : 'coupon-button-active'}`}
                onClick={() => (value.cartCouponType === 'redeem') ? handleSelect(value.id, value.status) : null} >{`${selected.includes(value.id) ? 'เลือกแล้ว' : 'เลือก'}`}</button>
            </div>
            <div className="coupon-date">{`ใช้ได้ถึง ${getDateFormat(value.endDate)}`}</div>
          </div>
        </div>
      </div>
    )
  }

  const renderCoupons = (couponList) => {
    return (
      Array.isArray(couponList) &&
      couponList.length > 0 &&
      couponList.map((value, index) => {
        return (
          renderCouponContainer(value, index)
        );
      })
    );
  };

  return (
    <section>
      <LoadingOverlay
        text="Loading"
        spinner
        active={loading}
        styles={{ wrapper: { width: '100%', minHeight: '100%' } }}
      />
      <div className="content">
        {/* <InputCoupon cartId={props.cartId} callback={props.onClose} /> */}
        <div
          className="scroll"
          style={{ height: 'calc(100vh - 256px)' }}
        >
          {Array.isArray(eligibleCoupons) && eligibleCoupons.length > 0 &&
            <>
              <div className="label font-stock">{'คูปองที่ใช้ได้ในตะกร้านี้'}</div>
              {renderCoupons(eligibleCoupons)}
            </>
          }
          {Array.isArray(nonEligibleCoupons) && nonEligibleCoupons.length > 0 &&
            <>
              <div className="label disable-label font-stock">{'คูปองทั้งหมด'}</div>
              {renderCoupons(nonEligibleCoupons)}
            </>
          }
          {!(Array.isArray(eligibleCoupons) && eligibleCoupons.length &&
            Array.isArray(nonEligibleCoupons) && nonEligibleCoupons.length) &&
            <div className="empty-coupon-container">
              <img src="/images/No-coupon.svg" alt="" />
              <div>
                คุณไม่มีคูปองที่สามารถใช้ได้
              </div>
            </div>
          }
        </div>
      </div>
      <div className="product-panel-footer">
        <div className="select-promotion-footer font-larger">
          <div className="text-center">
            <button className={`away-button ${selected.length ? 'active' : ''}`} disabled={!selected.length} onClick={() => onSubmit()}>{TEXT_CONFIRM_BUTTON}</button>
          </div>
        </div>
      </div>
    </section>
  );
};

const mapStateToProps = (state) => {
  return {
    data: state.cartApi.data,
    loading: state.cartApi.loading,
    error: state.cartApi.error,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getCartData: (fields, cartId) => dispatch(getCartData(fields, cartId)),
  }
};

export default connect(mapStateToProps, mapDispatchToProps)(CouponPanel);
